module.exports = __webpack_public_path__ + "static/media/photo-of-white-cow-with-brown-eyes.65bdad0d.jpg";